import React, { createContext, useContext, useMemo } from 'react';
import { useLocationAdminData } from '../hooks/useLocationAdminData';

const LocationAdminContext = createContext(null);

export const LocationAdminProvider = ({ children }) => {
  const { 
    data, 
    isLoading, 
    error, 
    refetch, 
    isRefetching 
  } = useLocationAdminData();

  // Compute derived values
  const value = useMemo(() => {
    if (!data) {
      return {
        locations: [],
        orgUnits: [],
        counts: {},
        recentChanges: [],
        systemHealth: null,
        isLoading,
        error,
        refetch,
        isRefetching,
      };
    }

    return {
      // Raw data
      locations: data.locations || [],
      orgUnits: data.orgUnits || [],
      
      // Computed values
      counts: data.counts || {},
      
      // Additional data
      recentChanges: data.recentChanges || [],
      systemHealth: data.systemHealth || null,
      
      // For Structure/Units tabs (loaded separately)
      hierarchyStructure: data.hierarchyStructure || null,
      activeOrgUnits: data.activeOrgUnits || null,
      inactiveOrgUnits: data.inactiveOrgUnits || null,
      
      // Actions and state
      refetch,
      isLoading,
      isRefetching,
      error,
    };
  }, [data, isLoading, error, refetch, isRefetching]);

  return (
    <LocationAdminContext.Provider value={value}>
      {children}
    </LocationAdminContext.Provider>
  );
};

// Custom hook to use the context
export const useLocationAdmin = () => {
  const context = useContext(LocationAdminContext);
  
  if (!context) {
    throw new Error('useLocationAdmin must be used within LocationAdminProvider');
  }
  
  return context;
};

// Export for direct access if needed
export default LocationAdminContext;